"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var matchFirstNumber = function matchFirstNumber(value) {
  if (!value) {
    return 0;
  }
  var valueAsString = typeof value === 'number' ? value.toString() : value;

  // this will match the first occurrence of a number in a string
  var matches = valueAsString.match(/[0-9,]+(?:\.\d{0,2})?/);
  return matches && parseFloat(matches[0].replace(/,/g, '')) || 0;
};
var _default = exports.default = matchFirstNumber;